import "./loginLink.styles.scss";
interface LoginLinkProps {
  customMessage?: string;
}

const LoginLink = ({ customMessage }: LoginLinkProps) => {
  const linkText = customMessage ? customMessage : "pricing";

  function isElementVisible(element: Element) {
    const style = window.getComputedStyle(element);

    if (style.display == "none") {
      return false;
    } else {
      return true;
    }
  }

  function openSignInMenu() {
    const desktopStickyHeader = document.querySelectorAll(
      "#header-desktop .header-sticky-nav",
    );
    const mobileHeader = document.querySelectorAll("#header-mobile");

    // Mob/tab logic
    if (mobileHeader.length > 0 && isElementVisible(mobileHeader[0])) {
      const mobileNavSignIn = document.querySelectorAll(
        "#header-mobile .header-mobile-menu-bar .header-mobile-right-col .header-actions-container-desktop #NavigationActionSignIn #signin",
      );
      const signInMobile: HTMLElement = mobileNavSignIn[0] as HTMLElement;
      signInMobile.click();
    } else {
      // Desktop logic
      // Desktop sticky nav logic
      if (desktopStickyHeader.length > 0) {
        const stickyNavSignIn = document.querySelectorAll(
          "#header-desktop .header-sticky-nav #header-main-nav-container .fixed-header-actions-container.show-fixed-header-actions .header-actions-container-desktop #NavigationActionSignIn #signin",
        );
        const stickySignInDesktop: HTMLElement =
          stickyNavSignIn[0] as HTMLElement;
        stickySignInDesktop.click();
      } else {
        const nonStickyNavSignIn = document.querySelectorAll(
          "#header-desktop .header-utility-menu-desktop .header-actions-container-desktop #NavigationActionSignIn #signin",
        );
        const nonStickySignInDesktop: HTMLElement =
          nonStickyNavSignIn[0] as HTMLElement;
        nonStickySignInDesktop.click();
      }
    }
  }

  return (
    <a
      className="login_link"
      role="button"
      href="javascript:void(0)"
      onClick={openSignInMenu}
    >
      Sign in for {linkText}
    </a>
  );
};

export default LoginLink;
